var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"synchronized-proportion-div position-relative",style:(_vm.cssVars)},[_c('div',{staticClass:"w-100 h-100 t-0 l-0",class:[_vm.innerClasses, {
        "position-absolute": _vm.proportion
    }]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }